import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const statusColors: Record<string, string> = {
  open: 'bg-blue-100 text-blue-800 border-blue-200',
  waiting_on_user: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  waiting_on_admin: 'bg-orange-100 text-orange-800 border-orange-200',
  resolved: 'bg-green-100 text-green-800 border-green-200',
  archived: 'bg-gray-100 text-gray-800 border-gray-200',
}

const statusLabels: Record<string, string> = {
  open: 'Open',
  waiting_on_user: 'Waiting on User',
  waiting_on_admin: 'Waiting on Admin',
  resolved: 'Resolved',
  archived: 'Archived',
}

const categoryColors: Record<string, string> = {
  bug: 'bg-red-100 text-red-800 border-red-200',
  feature: 'bg-purple-100 text-purple-800 border-purple-200',
  question: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  general: 'bg-gray-100 text-gray-800 border-gray-200',
}

const priorityColors: Record<string, string> = {
  low: 'bg-gray-100 text-gray-600 border-gray-200',
  normal: 'bg-blue-50 text-blue-700 border-blue-200',
  high: 'bg-orange-100 text-orange-800 border-orange-200',
  urgent: 'bg-red-100 text-red-800 border-red-200',
}

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge variant="outline" className={cn('text-[10px] font-medium', statusColors[status])}>
      {statusLabels[status] ?? status}
    </Badge>
  )
}

export function CategoryBadge({ category }: { category: string }) {
  return (
    <Badge variant="outline" className={cn('text-[10px] font-medium capitalize', categoryColors[category])}>
      {category}
    </Badge>
  )
}

export function PriorityBadge({ priority }: { priority: string }) {
  return (
    <Badge variant="outline" className={cn('text-[10px] font-medium capitalize', priorityColors[priority])}>
      {priority}
    </Badge>
  )
}
